import { render, staticRenderFns } from "./InsightEditBox.vue?vue&type=template&id=05afe023&scoped=true"
import script from "./InsightEditBox.vue?vue&type=script&lang=ts"
export * from "./InsightEditBox.vue?vue&type=script&lang=ts"
import style0 from "./InsightEditBox.vue?vue&type=style&index=0&id=05afe023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05afe023",
  null
  
)

export default component.exports